module.exports = __webpack_public_path__ + "img/petrifactionImg2.bfcee972.jpg";